export const FOLLOW_PRODUCT_REDIRECT_KEY = 'FOLLOW_PRODUCT_REDIRECT';

export interface IFollowRedirectData {
  redirectUrl?: string;
  productUuid?: string;
  shouldOpenFollowModal?: boolean;
}
